{"rating":"4.9","reviewCount":"139","fetchedAt":"2026-10-03T04:52:32.517Z","source":"place-details"}